"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngageLogger = exports.FLAGON_NAME_LOG_ERROR = exports.FLAGON_NAME_LOG_INFO = void 0;
const operationTracking_1 = require("./operationTracking");
const ResponseError_1 = require("./ResponseError");
exports.FLAGON_NAME_LOG_INFO = 'engage-messaging-log-info';
exports.FLAGON_NAME_LOG_ERROR = 'engage-messaging-log-error';
class EngageLogger extends operationTracking_1.OperationLogger {
    static getTryCatchFinallyHook(_ctx) {
        const msgSender = _ctx.funcThis;
        return msgSender?.logger;
    }
    constructor(actionPerformer) {
        super();
        this.actionPerformer = actionPerformer;
        this.logDetails = {};
        this.channelType = this.actionPerformer.getChannelType().toUpperCase();
    }
    get loggerClient() {
        return this.actionPerformer.executeInput.logger;
    }
    logInfo(msg, metadata) {
        if (!this.actionPerformer.isFeatureActive(exports.FLAGON_NAME_LOG_INFO, () => false))
            return;
        try {
            const msgs = [msg, ...(metadata ? [JSON.stringify(metadata)] : [])];
            const [firstMsg, ...rest] = msgs;
            this.loggerClient?.info(`TE Messaging: ${this.channelType} ${firstMsg}`, ...rest, JSON.stringify({ ...this.logDetails, ...metadata }));
        }
        catch {
        }
    }
    logError(msg, metadata) {
        if (!this.actionPerformer.isFeatureActive(exports.FLAGON_NAME_LOG_ERROR, () => false))
            return;
        try {
            const msgPrefix = `⛔ TE Messaging: ${this.channelType}`;
            this.loggerClient?.error(`${msgPrefix} ${msg}`, JSON.stringify({ ...this.logDetails, ...metadata }));
        }
        catch {
        }
    }
    logWarn(msg, metadata) {
        if (!this.actionPerformer.isFeatureActive(exports.FLAGON_NAME_LOG_INFO, () => false))
            return;
        try {
            const msgPrefix = `⛔ TE Messaging: ${this.channelType}`;
            this.loggerClient?.warn?.(`${msgPrefix} ${msg}`, JSON.stringify({ ...this.logDetails, ...metadata }));
        }
        catch {
        }
    }
    error(msg, metadata) {
        return this.logError(msg, metadata);
    }
    info(msg, metadata) {
        return this.logInfo(msg, metadata);
    }
    warn(msg, metadata) {
        return this.logWarn(msg, metadata);
    }
    getErrorMessage(error) {
        const errorDetails = (0, ResponseError_1.getErrorDetails)(error);
        let res = `${errorDetails?.message}`;
        if (errorDetails?.code)
            res += `. Code: ${errorDetails.code}`;
        if (errorDetails?.status)
            res += `. Status: ${errorDetails.status}`;
        return res;
    }
}
exports.EngageLogger = EngageLogger;
//# sourceMappingURL=EngageLogger.js.map